const API_BASE = {
    url: "https://devvendoraws.nzttool.it/apisrc/public/api/",
    // url: "https://vendor.nzttool.it/apisrc/public/api/",
    // url: "http://localhost/nztvendor/nztvendor_back/public/api/",
}

export default API_BASE;